// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../node_modules/css-loader/index.js?minimize!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-2d84653f\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/index.js!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./basicInfo.vue");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../../node_modules/vue-loader/node_modules/vue-style-loader/lib/addStylesClient.js")("f6fba1dc", content, true);


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/~/vue-style-loader!./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-2d84653f","scoped":true,"hasInlineConfig":false}!./~/less-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/modules/supplierapply/audit/basicInfo.vue
// module id = 615
// module chunks = 0